import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Http, XHRBackend, HttpModule, RequestOptions } from '@angular/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './home/header/header.component';
import { FooterComponent } from './home/footer/footer.component';
import { MainComponent } from './home/main/main.component';
import { HomeComponent } from './home/home.component';
import { CompanyModule } from './home/company/company.module';
import { ProductModule } from './home/product/product.module';
import { RecruitModule } from './home/recruit/recruit.module';
import { FormsModule } from '@angular/forms';
import { RecruitComponent } from './home/recruit/recruit.component';
import { NewsModule } from './home/news/news.module';
import { AdminComponent } from './admin/admin.component';
import { AdminModule } from './admin/admin.module';
import { ConfirmDialogComponent } from './service/confirm-dialog/confirm-dialog.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    HomeComponent,
    ConfirmDialogComponent,
    
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    CompanyModule,
    ProductModule,
    RecruitModule,
    FormsModule,
    NewsModule,
    AdminModule
  ],
  providers: [
	{
		provide: Http,
		deps: [XHRBackend, RequestOptions]
	}
],
  bootstrap: [AppComponent]
})
export class AppModule { }
